import * as yup from "yup";

const RxProductActionContentValidation = yup.object().shape({
	licence: yup.string().when("licenceEys", {
		is: (licenceEys: string) => licenceEys === null,
		then: yup
			.string()
			.required()
			.test(
				"licenceLength",
				"Lisans numarası seçilmelidir.",
				(val) =>
					val?.length === 19 || val?.startsWith("Yeni Lisans") === true
			),
	}),
});

export default RxProductActionContentValidation;
